import { AUSTRALIA_PRODUCTION_SITE_URL } from './storefrontEnvironment.js'

export const AUSTRALIA_PRODUCTION_SHOP_ID = '920703319745835029'
const PREVIOUS_AUSTRALIA_SHOP_ID = '920703319745835031'
const SHOP_ID_FIELDS = new Set(['dealerShopId', 'shopId', 'shopid'])

function isAustraliaProductionSite(currentServer = '') {
  try {
    const server = String(currentServer || '').trim()
    const hostname = new URL(/^https?:\/\//i.test(server) ? server : `https://${server}`).hostname
    return hostname === new URL(AUSTRALIA_PRODUCTION_SITE_URL).hostname
  } catch {
    return false
  }
}

export function resolveStorefrontShopId(value, currentServer) {
  const shopId = String(value || '').trim()
  return shopId === PREVIOUS_AUSTRALIA_SHOP_ID && isAustraliaProductionSite(currentServer)
    ? AUSTRALIA_PRODUCTION_SHOP_ID
    : shopId
}

// Only migrate shop identifiers on this site; order IDs and other shops stay intact.
export function normalizeStorefrontShopData(value, currentServer) {
  if (!isAustraliaProductionSite(currentServer)) return value

  const normalize = (record) => {
    if (Array.isArray(record)) return record.map(normalize)
    if (!record || Object.prototype.toString.call(record) !== '[object Object]') return record
    const entries = Object.entries(record).map(([key, item]) => {
      if (SHOP_ID_FIELDS.has(key) && String(item || '').trim() === PREVIOUS_AUSTRALIA_SHOP_ID) {
        return [key, AUSTRALIA_PRODUCTION_SHOP_ID]
      }
      if (key === 'configData' && typeof item === 'string') {
        try {
          return [key, JSON.stringify(normalize(JSON.parse(item)))]
        } catch {
          return [key, item]
        }
      }
      return [key, normalize(item)]
    })
    return Object.fromEntries(entries)
  }

  return normalize(value)
}

export function normalizeStorefrontShopUrl(url, currentServer) {
  if (!isAustraliaProductionSite(currentServer) || !String(url).includes('?')) return url
  const queryStart = url.indexOf('?')
  const query = new URLSearchParams(url.slice(queryStart + 1))
  let changed = false
  for (const key of SHOP_ID_FIELDS) {
    if (query.get(key) === PREVIOUS_AUSTRALIA_SHOP_ID) {
      query.set(key, AUSTRALIA_PRODUCTION_SHOP_ID)
      changed = true
    }
  }
  return changed ? `${url.slice(0, queryStart)}?${query}` : url
}
